import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '@reducers/index';
import { gridOptionModel } from '@models/gridModel';
import { IExplorerKeywordType } from '@models/keyword/keywordModel';
import { keywordExplorerOption } from '@classes/options/grid/keyword/keywordExplorer';
import GridAtom from '@components/atom/grid/grid';

const ExplorerGridBox = () => {
  const { keywordGridData } = useSelector(({ keywordExplore }: RootState) => keywordExplore);

  const [gridData, setGridData] = useState<gridOptionModel<IExplorerKeywordType>>(null);

  useEffect(() => {
    if (keywordGridData) {
      setGridData(new keywordExplorerOption().explorerGridOption(keywordGridData));
    }
  }, [keywordGridData]);

  return (
    <div className="competitor-kword">
      <div className="keyword-data">
        <h2 className="keyword-data-tit">Competitor's Keywords</h2>
      </div>
      <div className="tb-basic-wrap">
        <div className="tb-basic-inner">
          <GridAtom {...gridData} height="745px" />
        </div>
      </div>
    </div>
  );
};

export default ExplorerGridBox;
